export default __webpack_public_path__ + "static/media/image1.f33988f0.png";